<template>
    <section class="sk-home__section sk-home__section--skeleton sk-home__sb-cats--skeleton kts-pt-50 kts-pt-mb-50 kts-pb-25 kts-pb-mb-25">
        <div class="sk-home__container">
            <div class="sk-home__heading">
                <div class="sk-home__heading-title"></div>
                <div class="sk-home__heading-description"></div>
            </div>
            <div class="sk-home__content sk-home__content--sb-cats kts-pt-30 kts-pt-mb-30">
                <div class="sb-cats__items">
                    <div class="sb-cats__item" v-for="item in resultProduct" :key="item">
                        <div class="sb-cats__item-details"> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup lang="ts">
    const resultProduct = ref(5);

    function handleResize() {
        if (document.body.clientWidth > 991) {
            resultProduct.value = 5;
        } else if ( document.body.clientWidth > 767 && document.body.clientWidth <= 991 ) {
            resultProduct.value = 4;
        } else if ( document.body.clientWidth < 767 && document.body.clientWidth > 426 ) {
            resultProduct.value = 3;
        }
        else {
            resultProduct.value = 8;
        }
    }
    onMounted(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", handleResize);
    });
</script>